import React from 'react';
import { AlertTriangleIcon, LockIcon } from 'lucide-react';
import { integrations } from '../../data/integrations';
import { productionGates } from '../../data/ownerInputs';
import { serverInterfaces } from '../../utils/bookingApi';
import { StatusBadge } from './StatusBadge';
export function IntegrationsPanel() {
  const tested = integrations.filter(i => i.status === 'connected_tested').length;
  return <div className="space-y-10" data-id="element-99" data-mp="2j4pdn5sv690i">
      <section className="grid gap-6 rounded-2xl bg-ink p-6 text-white lg:grid-cols-[1.3fr_1fr]" data-id="element-100" data-mp="2j4fthyui2w2q">
        <div data-id="element-101" data-mp="2o1zdlfdvq32l">
          <p className="flex items-center gap-2 text-sm font-semibold text-magenta" data-id="element-102" data-mp="2o4lfozi03qdf">
            <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-103" data-mp="29bs25jmahkbe" /> Paid booking: DISABLED · Public flow: “Request your estimate” (preview)
          </p>
          <h2 className="mt-2 font-display text-3xl font-black" data-id="element-104" data-mp="322a1qant13k2">
            {tested} of {integrations.length} connections tested
          </h2>
          <p className="mt-3 max-w-xl text-[15px] leading-relaxed text-ink-200" data-id="element-105" data-mp="36ujoxixjbpin">
            Customers can build their move, see an itemized hourly estimate, accept it and see applicable documents. Without a backend, requests stay on the device and the status page says so. No paid, signed, verified or confirmed state can appear.
          </p>
        </div>
        <ul className="space-y-2 text-sm" data-id="element-106" data-mp="2blgkckdm80df">
          {productionGates.map(g => <li key={g} className="flex items-center justify-between gap-3 border-b border-ink-700 pb-2" data-id="element-107" data-mp="2pclpu33nzmvo">
              <span className="text-ink-100" data-id="element-108" data-mp="2ketnef5e8id8">{g}</span>
              <span className="whitespace-nowrap text-xs font-semibold text-ink-400" data-id="element-109" data-mp="2kg4qsduxfo3t">Not passed</span>
            </li>)}
        </ul>
      </section>

      <div className="flex items-start gap-3 rounded-xl border border-magenta/30 bg-magenta-soft p-4 text-[15px] text-ink" data-id="element-110" data-mp="2ud9guorw83pw">
        <AlertTriangleIcon className="mt-0.5 h-5 w-5 shrink-0 text-magenta-dark" aria-hidden="true" data-id="element-111" data-mp="14xjt0hydjx9m" />
        <p data-id="element-112" data-mp="1001emc1l8pu8">
          <strong data-id="element-113" data-mp="1009ri3xpnv5f">Platform limitation:</strong> Magic Patterns builds the frontend only. HighLevel tokens, Stripe secrets, webhook secrets and Meta CAPI tokens must live in a separate server — never in this bundle, localStorage or URLs.
        </p>
      </div>

      <div className="overflow-x-auto rounded-xl border border-ink-200 bg-white" data-id="element-114" data-mp="1ylzg2wjyec4d">
        <table className="w-full min-w-[820px] text-left text-sm" data-id="element-115" data-mp="23mdm691zvbzr">
          <thead className="border-b border-ink-200 bg-ink-100 text-xs font-semibold text-ink-600" data-id="element-116" data-mp="28l6px9rhbomq">
            <tr data-id="element-117" data-mp="2cms89ams8v4b">
              <th className="px-4 py-3" data-id="element-118" data-mp="2cma3fpm218ks">Integration</th>
              <th className="px-4 py-3" data-id="element-119" data-mp="2ckp9o27kdtnz">Status</th>
              <th className="px-4 py-3" data-id="element-120" data-mp="2hd8m2vuimir7">Observed state</th>
              <th className="px-4 py-3" data-id="element-121" data-mp="2hfuuexp8d2ah">Missing values</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-ink-200 align-top" data-id="element-122" data-mp="2mepkmkpj1t4m">
            {integrations.map(i => <tr key={i.id} data-id="element-123" data-mp="2r9v5rhb3v3rn">
                <td className="px-4 py-4 font-semibold text-ink" data-id="element-124" data-mp="2wa9i3bjqozvh">{i.name}</td>
                <td className="px-4 py-4" data-id="element-125" data-mp="knfo9k0l667s">
                  <StatusBadge status={i.status} data-id="element-126" data-mp="koh4e2wgliwd" />
                </td>
                <td className="px-4 py-4 text-ink-700" data-id="element-127" data-mp="fntc7dwhuw0k">{i.detail}</td>
                <td className="px-4 py-4 text-ink-700" data-id="element-128" data-mp="fqpa528cdkp0">{i.missing}</td>
              </tr>)}
          </tbody>
        </table>
      </div>

      <section data-id="element-129" data-mp="5qybcocr0jj4">
        <h3 className="font-display text-lg font-extrabold text-ink" data-id="element-130" data-mp="5rghccp7qc48">Server interfaces the frontend calls (utils/bookingApi.ts)</h3>
        <p className="mt-1 text-sm text-ink-500" data-id="element-131" data-mp="13frpg3fi71gc">To be implemented on the backend. The frontend adapter already calls these when apiBaseUrl is set.</p>
        <ul className="mt-4 divide-y divide-ink-200 border-y border-ink-200 text-sm" data-id="element-132" data-mp="tn2gpgbc81op">
          {serverInterfaces.map(s => <li key={s.route} className="grid gap-1 py-2.5 md:grid-cols-[280px_1fr]" data-id="element-133" data-mp="oor6h4h4rp5y">
              <code className="font-mono text-xs font-semibold text-ink" data-id="element-134" data-mp="1m5zni74cj1po">{s.route}</code>
              <span className="text-ink-600" data-id="element-135" data-mp="1hcwr7r86pe5s">{s.purpose}</span>
            </li>)}
        </ul>
      </section>
    </div>;
}